import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  partners: null,
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;
  const partners = data;

  return {
    ...state,
    partners,
    total,
    filteredTotal,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
